import { render, staticRenderFns } from "./FamousCommentAllList.vue?vue&type=template&id=242d43c2&"
import script from "./FamousCommentAllList.vue?vue&type=script&lang=js&"
export * from "./FamousCommentAllList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports